const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const universityBgImage = imageBaseUrl + "International-Relation/University/Jis-University.avif";

const kolkata = imageBaseUrl + "International-Relation/University/kolkata.png";

const Fees_JIS_Africa = imageBaseUrl + "International-Relation/University/fee-structure/Fees_JIS_Africa.pdf";
const Fees_JIS_Middle_East = imageBaseUrl + "International-Relation/University/fee-structure/Fees_JIS_Middle East.pdf";
const Fees_JIS_SAARC = imageBaseUrl + "International-Relation/University/fee-structure/Fees_JIS_SAARC.pdf";

const k1 = imageBaseUrl + "universityKnow/k1.png";
const k2 = imageBaseUrl + "universityKnow/k2.png";
const k3 = imageBaseUrl + "universityKnow/k3.png";
const k4 = imageBaseUrl + "universityKnow/k4.png";
const k5 = imageBaseUrl + "universityKnow/k5.png";
const k6 = imageBaseUrl + "universityKnow/k6.png";

export const jisUniversityJson = {
  BannerData: {
    heading: "JIS University",
    backgroundImage: universityBgImage,
    content: (
      <>
        JIS University, established in 2014 in Kolkata, West Bengal, is a
        private university known for its multidisciplinary education and
        industry-driven curriculum. Approved by UGC, AICTE, and accredited by
        NAAC, the university offers undergraduate, postgraduate, and doctoral
        programs in engineering, management, law, pharmacy, hospitality, and
        more. With modern infrastructure, advanced laboratories, and research
        facilities, JIS University emphasizes experiential learning and skill
        development. It collaborates with global institutions and industries,
        ensuring strong placement support with top recruiters. The campus
        fosters holistic growth through cultural events, clubs, and
        extracurricular activities, making it a preferred choice for quality
        education and career growth
      </>
    ),
  },

  universityDetails: [
    {
      id: 1,
      title: "Name",
      subtitle: "JIS University",
      image: imageBaseUrl + "universityinfo/1.png",
    },
    {
      id: 2,
      title: "Location",
      subtitle: " Kolkata, West Bengal, India",
      image: imageBaseUrl + "universityinfo/2.png",
    },
    {
      id: 3,
      title: "Founded",
      subtitle: " 2014",
      image: imageBaseUrl + "universityinfo/3.png",
    },
    {
      id: 4,
      title: "Type",
      subtitle: "Private University",
      image: imageBaseUrl + "universityinfo/4.png",
    },
    {
      id: 5,
      title: "Total Enrollment",
      subtitle: "10,000+ students",
      image: imageBaseUrl + "universityinfo/5.png",
    },
    {
      id: 6,
      title: "International Students",
      subtitle: "30 to 50 foreign students annually (Exact number varies)",
      image: imageBaseUrl + "universityinfo/6.png",
    },
    {
      id: 7,
      title: "Total Students",
      subtitle: "10,000+",
      image: imageBaseUrl + "universityinfo/6.png",
    },

    {
      id: 8,
      title: "Website",
      subtitle: "Strengthening international recognition and credibility",
      image: imageBaseUrl + "universityinfo/7.png",
      url: "https://www.galgotiasuniversity.edu.in/",
    },
  ],

  WhyChooseThisUniversityPage: [
    {
      id: 1,
      rank: "101-150",
      title: <><b>NIRF Rankings 2024</b>: Overall University <b>Rank 101-150</b></>,
    },
    { id: 2, rank: "NAAC", title:<><b>NAAC</b> Accredited university</> },
    { id: 3, rank: "UGC & AICTE", title: <><b>UGC & AICTE</b> Approved</> },
  ],

  feeStructure: [
    { label: "Africa", value: "Africa", pdfFile: Fees_JIS_Africa },
    { label: "Middle East", value: "Middle East", pdfFile: Fees_JIS_Middle_East},
    { label: "SAARC", value: "Middle East", pdfFile: Fees_JIS_SAARC},
  ],

  KnowMore: [
    {
      title: "Campus Life",
      img: k1,
      url: "https://www.jisgroup.org/jis-campuses.html",
    },
    {
      title: "How to Apply",
      img: k2,
      url: "https://www.jisuniversity.ac.in/admission-procedure.php",
    },
    {
      title: "International Students",
      img: k3,
      url: "https://www.jisuniversity.ac.in/international-students.php",
    },

    {
      title: "Accommodation",
      img: k5,
      url: "https://www.jisuniversity.ac.in/hostel.php",
    },

    {
      title: "Placements statistics",
      img: k4,
      url: "https://www.jisuniversity.ac.in/placement.php",
    },
    {
      title: "Brochure",
      img: k6,
      url: "https://www.jisuniversity.ac.in/pdf/jisu-brochure24.pdf",
    },
  ],

  Location: {
    header: "KOLKATA",
    image: kolkata,
    content: (
      <>
        Kolkata boasts a rich academic heritage, abundant career opportunities,
        and a vibrant cultural scene, making it an ideal destination for
        international students. .<br></br>
        <br></br>
        <ul style={{"margin-left": "20px"}}>
          <li>
            <b>Renowned Institutions</b>
          </li>
          <li>
            <b>Thriving Career Opportunities</b>
          </li>
          <li>
            <b>Cultural & Literary Hub</b>
          </li>
          <li>
            <b>Excellent Connectivity</b>
          </li>
          <li>
            <b>Safe & Affordable</b>
          </li>
        </ul>
      </>
    ),
  },
};
